module.exports = __webpack_public_path__ + "static/media/BSOS-Commencement-300x250.26b54751.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ads/BSOS-Commencement-300x250.gif
// module id = 29
// module chunks = 0